export default function ThreeDotsLoading({children, ...rest}) {
    return (
        <div className="three-dots-loading" {...rest}>
            {children}
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
        </div>
    );
};